export default "__VITE_ASSET__CsEE740R__"